import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setDeal } from 'bundles/apex/deals/show/store/deal/actions';
import { setFields } from 'bundles/apex/deals/show/store/fields/actions';
import { stopEditing } from 'bundles/apex/deals/show/store/overview/actions';

import Form from 'bundles/apex/deals/form';
import layouts from 'bundles/apex/deals/form/layouts';

export function OverviewForm({
  deal,
  features,
  fields,
  forUser,
  invalidFields,
  options,
  paths,
  setDeal,
  setFields,
  stopEditing
}) {
  function onSave(deal, fields) {
    setDeal(deal);
    setFields(fields);
    stopEditing();
  }

  return (
    <Form
      deal={deal}
      features={features}
      fields={fields}
      forUser={forUser}
      invalidFields={invalidFields}
      layout={layouts.overview}
      options={options}
      paths={paths}
      onCancel={stopEditing}
      onSave={onSave}
    />
  );
}

OverviewForm.propTypes = {
  deal: PropTypes.object.isRequired,
  features: PropTypes.object,
  fields: PropTypes.object.isRequired,
  forUser: PropTypes.object,
  invalidFields: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.object,
  paths: PropTypes.object,
  setDeal: PropTypes.func.isRequired,
  setFields: PropTypes.func.isRequired,
  stopEditing: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  features: state.features,
  fields: state.fields,
  forUser: state.forUser,
  invalidFields: state.invalidFields,
  options: state.options,
  paths: state.paths,
});

const mapDispatchToProps = {
  setDeal,
  setFields,
  stopEditing,
};

export default connect(mapStateToProps, mapDispatchToProps)(OverviewForm);
